import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Avatar,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Container,
  IconButton,
} from "@mui/material";
import { ConsultantuseAuth } from "../../security/ConsultantUseAuth";
import { ArrowBack, ArrowForward } from "@mui/icons-material";

import { Consultant_Get_One_From_MongoDB } from "../../api/Consultant_Get_One_From_MongoDB";
import GetClientAddress from "../../../functions/GetClientAddress";
import { Get_One_From_MongoDB } from "../../api/Get_One_From_MongoDB";
import { Consultant_Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort } from "../../api/Consultant_Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort } from "../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort";

import { Get_All_From_MongoDB_With_Search_Prop_In_Array } from "../../api/Get_All_From_MongoDB_With_Search_Prop_In_Array";

const ConsultantTest = () => {
  const { logoutConsultant } = ConsultantuseAuth();

  function handleOpenOfficialWebsite() {
    window.open(`https://investin.org`);
  }
  function handleOpenBespokeForm() {
    window.open(
      `${GetClientAddress()}Public/RegistrationForm/${localStorage.getItem(
        "Consultant_id"
      )}`
    );
  }
  function handleOpenSXPSite() {
    window.open(`https://investin.org/collections/summer-schools`);
  }

  let Arr_Staff = [
    {
      name: "Richard Lawless",
      email: "richard.lawless@investin.org",
      description: "International Partnerships",
      photo:
        "https://media.licdn.com/dms/image/D4D03AQGvHljWW95rFw/profile-displayphoto-shrink_400_400/0/1682581811260?e=2147483647&v=beta&t=ky7EUVx68wNUIUdG4EPMenQeA3d9sWFKMfYZmEvyPw4",
      details: "For all your pre bookings support",
      _id: "65c38d2d72976acb3923336c",
    },
    {
      name: "Shu-Han Chang",
      email: "shu@investin.org",
      description: "International Partnerships",
      photo:
        "https://media.licdn.com/dms/image/v2/C5603AQGJU7Hmj2oZqA/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1516771690372?e=2147483647&v=beta&t=756nm_OeSEHdEGckroViZETYbLD6ox4od4JbAsmvuLk",
      details: "For all your pre bookings support",
      _id: "65c38d6972976acb3923336d",
    },
    {
      name: "Curtis",
      email: "curtis@investin.org",
      description: "Head of IT",
      photo:
        "https://media.licdn.com/dms/image/C4E03AQHLu92IDxD-nw/profile-displayphoto-shrink_200_200/0/1637082190802?e=2147483647&v=beta&t=oERrNItf6BSNwaBi49tffDiC3uANUqMw9zOd3hvgHt4",
      details: "For all your platform support",
    },
    {
      name: "Rebecca Joyce",
      email: "rebecca@investin.org",
      description: "Senior International Student Experience Manager",
      photo:
        "https://media.licdn.com/dms/image/v2/C5603AQGCdgzhW4HVYw/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1637011448746?e=2147483647&v=beta&t=9-zRoIs0QY2eouFgPekhipiXncSxGb1EPhdIEysmSXg",
      details: "For all your post bookings support",
    },
    {
      name: "Arsbi Amat",
      email: "arsbi@investin.org",
      description: "International Student Experience Manager",
      photo:
        "https://media.licdn.com/dms/image/v2/D4E03AQGZpSo1k1KM7g/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1719853179311?e=1735776000&v=beta&t=_WogJuXBrU_7PPDB6OjIuCpTt6tB1RqsfLRmeu0N5AA",
      details: "For all your post bookings support",
    },
  ];

  //Part 1, get bookings data
  const [Arr_Bookings, setArr_Bookings] = useState([]);
  useEffect(() => {
    const fetchAttendeeData = async () => {
      Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort(
        "Registers_2025",
        "All",
        { "IPInfo.EC_ID": localStorage.getItem("Consultant_id") },
        1000,
        setArr_Bookings,
        {},
        {},
        logoutConsultant
      );
    };
    fetchAttendeeData();
  }, []);

  //part 2, get all id's from bookings
  const getCompiledArray = async () => {
    // Wait for the state to update
    return new Promise((resolve) => {
      setTimeout(() => {
        let Arr_Bookingid = Arr_Bookings.map((obj) => obj._id);
        resolve(Arr_Bookingid);
      }, 0);
    });
  };

  //part 3, use the id's from bookings to find all invoices
  const [Arr_Invoices, setArr_Invoices] = useState([]);
  const fetchInvoiceData = async () => {
    const compiledArray = await getCompiledArray();

    Get_All_From_MongoDB_With_Search_Prop_In_Array(
      "Invoices",
      "Xero_2025",
      "Attendees.Attendee_id",
      compiledArray,
      setArr_Invoices,
      logoutConsultant
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      // Part 1: Fetch attendee data
      //await fetchAttendeeData();
      // Part 2: Get all IDs from bookings
      const compiledArray = await getCompiledArray();
      // Part 3: Use the IDs from bookings to find all invoices
      await fetchInvoiceData(compiledArray);
    };
    fetchData();
  }, [Arr_Bookings]);

  let Arr_Materials = [
    {
      Header: "InvestIN Dates and Fees PDF 24-25",
      Link: "https://docsend.com/view/hq3n7q8x4mu85jzm",
    },
    {
      Header: "InvestIN Work Experience Programmes 19-24",
      Link: "https://docsend.com/view/8kn5gxktwmgs2kmj",
    },
    {
      Header: "Agent sales guide 2024-25 Global",
      Link: "https://docsend.com/view/yq7yacf4d6j8sgag",
    },
    {
      Header: "InvestIN Summer Trailer 2025",
      Link: "https://docsend.com/view/qg4qb7a3mcbtd473",
    },
    {
      Header: "The Best Way to Get Work Experience This 2025 Summer",
      Link: "https://www.youtube.com/embed/DtTz-ogyoR4",
    },
    {
      Header: "The Ultimate Work Experience: Summer 2025 (for ages 15-18)",
      Link: "https://www.youtube.com/embed/kqqciQwyIp0",
    },
    {
      Header: "How to Meet Professionals in Your Dream Job",
      Link: "https://www.youtube.com/embed/AACZCoRhiAw",
    },
    {
      Header: "Get a Work Experience Qualification & UCAS points!",
      Link: "https://www.youtube.com/embed/vWWneFMcuxc",
    },
  ];

  const BoxMINE = ({ Header, Link }) => {
    return (
      <div
        style={{
          width: "600px",
          height: "450px",
          margin: "5px",
          padding: "5px",
          fontSize: "30px",
        }}
      >
        <a href={Link || ""} title={Header}>
          <h3 style={{ fontsize: "18px", color: "#ffffff" }}>
            <u>{Header || ""}</u>
          </h3>
        </a>
        <iframe
          src={Link || "https://example.com"}
          allow="fullscreen"
          width="100%"
          height="80%"
        ></iframe>
      </div>
    );
  };

  return (
    <div>
      <link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css" />
      <link
        rel="stylesheet"
        href="https://www.w3schools.com/lib/w3-theme-black.css"
      />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      />
      {/* <!-- Image Header --> */}
      <div class="w3-display-container w3-animate-opacity">
        <img
          //src={`${process.env.PUBLIC_URL}/InvestINBannerLogo.png`}
          src={
            "https://media.licdn.com/dms/image/v2/C4D1BAQFfSGiz0Rf-Ow/company-background_10000/company-background_10000/0/1629385576959/investin_cover?e=2147483647&v=beta&t=TFD75WPwhzNKP0Y-eeN1yoYOyyxqYfaiwDfWRpp-SwU"
          }
          alt="InvestIN Banner Logo"
          style={{ width: "100%", minHeight: "350px", maxHeight: "550px" }}
        />

        <div class="w3-container w3-display-bottomleft w3-margin-bottom">
          <button
            onclick={handleOpenOfficialWebsite}
            title=" Go To Offical Website"
          >
            Go To Offical Website
          </button>
        </div>
      </div>
      {/* <!-- Modal --> */}
      {/* <div id="id01" class="w3-modal">
        <div class="w3-modal-content w3-card-4 w3-animate-top">
          <header class="w3-container w3-teal w3-display-container">
            <span
              onclick="document.getElementById('id01').style.display='none'"
              class="w3-button w3-teal w3-display-topright"
            >
              <i class="fa fa-remove"></i>
            </span>
            <h4>Oh snap! We just showed you a modal..</h4>
            <h5>
              Because we can <i class="fa fa-smile-o"></i>
            </h5>
          </header>
          <div class="w3-container">
            <p>Cool huh? Ok, enough teasing around..</p>
            <p>
              Go to our{" "}
              <a class="w3-text-teal" href="/w3css/default.asp">
                W3.CSS Tutorial
              </a>{" "}
              to learn more!
            </p>
          </div>
          <footer class="w3-container w3-teal">
            <p>Modal footer</p>
          </footer>
        </div>
      </div> */}
      {/* <!-- Team Container --> */}
      <div class="w3-container w3-padding-64 w3-center" id="team">
        <h2>OUR TEAM</h2>
        <p>Meet the team - our office rats:</p>

        <div class="w3-row">
          <br></br>
          {Arr_Staff.map((obj_staff, index) => (
            <div class="w3-quarter" style={{ width: "19.99999%" }}>
              <a href={`mailto:${obj_staff.email}`}>
                <img
                  src={obj_staff.photo}
                  alt={obj_staff.name}
                  style={{ width: "45%" }}
                  class="w3-circle w3-hover-opacity"
                />
              </a>
              <h3>{obj_staff.name}</h3>
              <p>{obj_staff.email}</p>
              <p>{obj_staff.description}</p>
              <p>{obj_staff.details}</p>
            </div>
          ))}
        </div>
      </div>

      {/* <!-- Invoices --> */}
      <div class="w3-row-padding w3-center w3-padding-64" id="contact">
        <div class="w3-container">
          <h2>Invoices</h2>
          <p>Please see below a list of all Paid and Due Invoices:</p>
          <div class="w3-panel w3-pale-blue w3-leftbar w3-border-blue">
            <p class="w3-xlarge w3-serif">
              <i>: Paid</i>
            </p>
            <p>Due </p>
          </div>

          {/* {Arr_Invoices.map((obj_invoice, index) => (
            <>
              {obj_invoice.Paid_Status === "Paid" ? (
                <div class="w3-panel w3-pale-blue w3-leftbar w3-border-blue">
                  <p class="w3-xlarge w3-serif">
                    <i>{obj_invoice.Invoice_Number}: Paid</i>
                  </p>
                  <p>Due {obj_invoice.Due_Date}</p>
                </div>
              ) : (
                <></>
              )}

              {obj_invoice.Paid_Status === "UnPaid" ? (
                <div class="w3-panel w3-pale-red w3-leftbar w3-rightbar w3-border-red">
                  <p class="w3-xlarge w3-serif">
                    <i>{obj_invoice.Invoice_Number}: UnPaid</i>
                  </p>
                  <p>Due {obj_invoice.Due_Date}</p>
                </div>
              ) : (
                <></>
              )}
            </>
          ))} */}
        </div>
      </div>

      {/* <!-- Summer Pricing Row --> */}
      <div class="w3-row-padding w3-center w3-padding-64" id="pricing">
        <h2>SUMMER PRICING</h2>
        <p>Choose a programme that fits your needs.</p>
        <br></br>
        <div class="w3-third w3-margin-bottom">
          <ul class="w3-ul w3-border w3-hover-shadow">
            <li class="w3-theme">
              <p class="w3-xlarge">1 Week</p>
            </li>
            <li class="w3-padding-16">
              <b>25</b> contact hours with professionals
            </li>
            <li class="w3-padding-16">
              <b>Up to 2</b> Excursions to professional workplaces/venues
            </li>
            <li class="w3-padding-16">Hands-on career simulations</li>
            <li class="w3-padding-16">
              Programme materials, equipment & resources
            </li>
            <li class="w3-padding-16">Digital certificate</li>
            <li class="w3-padding-16">On-site safeguarding & pastoral care</li>
            <li class="w3-padding-16">Experience UCL campus</li>
            <li class="w3-padding-16">
              <h2 class="w3-wide">
                <i class="fa fa-gbp"></i> 2,150
              </h2>
              <span class="w3-opacity">Residential package +£1,400</span>
            </li>
            <li class="w3-theme-l5 w3-padding-24">
              <button
                class="w3-button w3-teal w3-padding-large"
                onClick={handleOpenSXPSite}
              >
                <i class="fa fa-check"></i> See full details on our website
              </button>
            </li>
          </ul>
        </div>

        <div class="w3-third w3-margin-bottom">
          <ul class="w3-ul w3-border w3-hover-shadow">
            <li class="w3-theme-l2">
              <p class="w3-xlarge">2 Week</p>
            </li>
            <li class="w3-padding-16">
              <b>50</b> contact hours with professionals
            </li>
            <li class="w3-padding-16">
              <b>Up to 5</b> Excursions to professional workplaces/venues
            </li>
            <li class="w3-padding-16">
              + Assessment centre to improve on core skills & receive feedback
            </li>
            <li class="w3-padding-16">
              + Graduation ceremony & physical certificate
            </li>
            <li class="w3-padding-16">
              <b>+ £375</b> Level 3 Award in Work Experience & Assessment for
              UCAS Points
            </li>
            <li class="w3-padding-16">
              <h2 class="w3-wide">
                <i class="fa fa-gbp"></i> 3,150
              </h2>
              <span class="w3-opacity">Residential package +£3,000</span>
            </li>
            <li class="w3-theme-l5 w3-padding-24">
              <button
                class="w3-button w3-teal w3-padding-large"
                onClick={handleOpenSXPSite}
              >
                <i class="fa fa-check"></i> See full details on our website
              </button>
            </li>
          </ul>
        </div>

        <div class="w3-third w3-margin-bottom">
          <ul class="w3-ul w3-border w3-hover-shadow">
            <li class="w3-theme">
              <p class="w3-xlarge">2 Week Premium</p>
            </li>
            <li class="w3-padding-16">
              <b>65</b> contact hours with professionals
            </li>
            <li class="w3-padding-16">
              <b>Up to 5</b> Excursions to professional workplaces/venues
            </li>
            <li class="w3-padding-16">
              + Level 3 Award in Work Experience & Assessment for{" "}
              <b>UCAS Points</b>
            </li>
            <li class="w3-padding-16"> + Experience LSE campus </li>{" "}
            <li class="w3-padding-16">
              + Personalised professional development & university admissions
              coaching{" "}
            </li>{" "}
            <li class="w3-padding-16">
              + Personality & situational judgement testing{" "}
            </li>{" "}
            <li class="w3-padding-16">
              + Private Gala dinner & networking event with professionals{" "}
            </li>
            <li class="w3-padding-16">
              <h2 class="w3-wide">
                <i class="fa fa-gbp"></i> 4,250
              </h2>
              <span class="w3-opacity">Residential package +£3,000</span>
            </li>
            <li class="w3-theme-l5 w3-padding-24">
              <button
                class="w3-button w3-teal w3-padding-large"
                onClick={handleOpenSXPSite}
              >
                <i class="fa fa-check"></i> See full details on our website
              </button>
            </li>
          </ul>
        </div>
      </div>
      {/* <!-- Contact Container --> */}
      <div class="w3-container w3-padding-64 w3-theme-l5" id="contact">
        <div class="w3-row">
          <div class="w3-col m5">
            <div class="w3-padding-16">
              <span class="w3-xlarge w3-border-teal w3-bottombar">
                Contact Us
              </span>
            </div>
            <h3>Address</h3>
            <p>
              <i class="fa fa-map-marker w3-text-teal w3-xlarge"></i> Dukes
              House
            </p>
            <p>58 Buckingham Gate</p>
            <p>London SW1E 6AJ</p>
            <p>
              <i class="fa fa-phone w3-text-teal w3-xlarge"></i> +44 (0) 203 488
              5089
            </p>
            <p>
              <i class="fa fa-envelope-o w3-text-teal w3-xlarge"></i>{" "}
              info@investin.org
            </p>
          </div>
          <div class="w3-col m7">
            <form
              class="w3-container w3-card-4 w3-padding-16 w3-white"
              action="/action_page.php"
              target="_blank"
            >
              <div class="w3-section">
                <label>Name</label>
                <input class="w3-input" type="text" name="Name" required />
              </div>
              <div class="w3-section">
                <label>Email</label>
                <input class="w3-input" type="text" name="Email" required />
              </div>
              <div class="w3-section">
                <label>Message</label>
                <input class="w3-input" type="text" name="Message" required />
              </div>
              <input class="w3-check" type="checkbox" checked name="Like" />
              <label>I Like it!</label>
              <button type="submit" class="w3-button w3-right w3-theme">
                Send
              </button>
            </form>
          </div>
        </div>
      </div>
      {/* <!-- Footer --> */}
      <footer class="w3-container w3-padding-32 w3-theme-d1 w3-center">
        <h4>Follow Us</h4>
        <a
          class="w3-button w3-large w3-teal"
          href="https://www.facebook.com/@investineducation/"
          title="Facebook"
        >
          <i class="fa fa-facebook"></i>
        </a>
        <a
          class="w3-button w3-large w3-teal"
          href="https://twitter.com/investin_ed"
          title="Twitter"
        >
          <i class="fa fa-twitter"></i>
        </a>

        <a
          class="w3-button w3-large w3-teal"
          href="https://www.instagram.com/investin_education/?hl=en"
          title="Instagram"
        >
          <i class="fa fa-instagram"></i>
        </a>
        <a
          class="w3-button w3-large w3-teal w3-hide-small"
          href="https://uk.linkedin.com/company/investin"
          title="Linkedin"
        >
          <i class="fa fa-linkedin"></i>
        </a>
        <a
          class="w3-button w3-large w3-teal"
          href="https://investin.org/"
          title="Website"
        >
          <i class="fa fa-globe"></i>
        </a>
      </footer>
    </div>
  );
};

export default ConsultantTest;
